import * as S from "fp-ts/string"
import { trim } from "./string"

export const websiteUrl = (slug: string): string => combinePaths("https://www.silversea.com", `${slug}.html`)

const isNotEmpty = (s: string) => !S.isEmpty(s)

export const combinePaths = (...paths: string[]): string => {
    if (paths.length == 0) return ""
    if (paths.length == 1) return paths[0]

    let trimmed = paths.map(trim("/")).filter(isNotEmpty).join("/")
    if (paths[0].startsWith("/")) trimmed = "/" + trimmed
    if (paths[paths.length - 1].endsWith("/")) trimmed = trimmed + "/"

    return trimmed
}
